const eMessage = (e: unknown, message = '') => (e instanceof Error ? e.message : message);

export default eMessage;